import { Fragment } from "react";
import { AvisoAtualizacao } from "../components/AvisoAtualizacao.tsx";
import { useVersao } from "../lib/dispositivo.ts";
import { FormularioImgr } from "../publico/FormularioImgr.tsx";
import { AppDesktop } from "./AppDesktop.tsx";
import { AppMobile } from "./AppMobile.tsx";

/** Token do formulário público quando a rota é `/q/:token` (fora do shell). */
function tokenPublico(): string | null {
  const m = window.location.pathname.match(/^\/q\/([^/]+)\/?$/);
  return m?.[1] ? decodeURIComponent(m[1]) : null;
}

/**
 * Raiz: escolhe a casca pela versão detectada automaticamente (mobile/PWA ×
 * desktop). Cada casca tem layout próprio (não é responsivo) e compartilha o
 * mesmo núcleo via `useAppState`. Sem alternância manual — é automático.
 *
 * Login ÚNICO: a conta `unidade` entra pela MESMA tela; a casca detecta o perfil
 * e mostra só a view do Plano de Ação (não há mais rota/login `/unidade`).
 *
 * Exceção: a rota pública `/q/:token` (questionário IMGR) renderiza a
 * página standalone, SEM autenticação e fora de ambas as cascas.
 */
export function App() {
  const versao = useVersao();
  const token = tokenPublico();
  if (token) {
    return <FormularioImgr token={token} />;
  }
  return (
    <Fragment>
      {versao === "desktop" ? <AppDesktop /> : <AppMobile />}
      <AvisoAtualizacao />
    </Fragment>
  );
}
